import { IC_CalculationTrace } from 'src/app/Interface/IC_Interface';
type IC_CalculationStep = IC_CalculationTrace['steps'][number];

// Display only; saved formulas/results and backend decisions remain authoritative.
export function icScientificTitle(step: IC_CalculationStep): string {
  return step.code === 'ExpandedUncertainty'
    ? 'شاخص قدیمی ریشه مجموع مربعات عدم قطعیت‌ها و اریبی؛ عدم قطعیت گسترده U نیست (ExpandedUncertainty)'
    : ['t95', 't99'].includes(step.code) && step.title === step.code
    ? `${step.code}: آمار تاریخی؛ سطح احتمال طبق فرمول ذخیره‌شده است`
    : step.title;
}
export function icScientificNotice(step: IC_CalculationStep): string {
  return step.code === 'ExpandedUncertainty'
    ? 'این مقدار قدیمی اطلاعاتی است. مدل و ضریب kU برای U=kU×uc مشخص نیست؛ k فعلی ضریب سازگاری مترولوژیک است.'
    : ['t95', 't99'].includes(step.code) && step.title === step.code
    ? 'نام تاریخی به‌تنهایی به معنی فاصله ۹۵٪ یا ۹۹٪ نیست. این آمار مبنای PASS/FAIL تجهیز نیست. ' + (step.description || '')
    : step.description || '';
}
